/*
 * SchedulingForm Messages
 *
 * This contains all the text for the SchedulingForm component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.SchedulingForm';

export default defineMessages({
  summary: {
    id: `${scope}.summary`,
    defaultMessage: 'Summary',
  },
  newSummary: {
    id: `${scope}.newSummary`,
    defaultMessage: 'New Summary',
  },
  newScheduling: {
    id: `${scope}.newScheduling`,
    defaultMessage: 'New Scheduling',
  },
  previousScheduling: {
    id: `${scope}.previousScheduling`,
    defaultMessage: 'Previous Scheduling',
  },
  pickStartDatePlaceholder: {
    id: `${scope}.pickStartDatePlaceholder`,
    defaultMessage: 'Pick launch date',
  },
  pickCustomStartDatePlaceholder: {
    id: `${scope}.pickCustomStartDatePlaceholder`,
    defaultMessage: 'Pick date',
  },
  pickEndDatePlaceholder: {
    id: `${scope}.pickEndDatePlaceholder`,
    defaultMessage: 'Pick end date',
  },
  timezonePlaceholder: {
    id: `${scope}.timezonePlaceholder`,
    defaultMessage: 'Timezone',
  },
  surveyScheduling: {
    id: `${scope}.surveyScheduling`,
    defaultMessage: 'Survey Scheduling',
  },
  editScheduling: {
    id: `${scope}.editScheduling`,
    defaultMessage: 'Edit Scheduling',
  },
  launchNow: {
    id: `${scope}.launchNow`,
    defaultMessage: 'Launch now',
  },
  noneLabel: {
    id: `${scope}.noneLabel`,
    defaultMessage: 'No schedule',
  },
  onceLabel: {
    id: `${scope}.onceLabel`,
    defaultMessage: 'Once',
  },
  dailyLabel: {
    id: `${scope}.dailyLabel`,
    defaultMessage: 'Daily',
  },
  weeklyLabel: {
    id: `${scope}.weeklyLabel`,
    defaultMessage: 'Weekly',
  },
  monthlyLabel: {
    id: `${scope}.monthlyLabel`,
    defaultMessage: 'Monthly',
  },
  quarterlyLabel: {
    id: `${scope}.quarterlyLabel`,
    defaultMessage: 'Quarterly',
  },
  customLabel: {
    id: `${scope}.customLabel`,
    defaultMessage: 'Custom',
  },
  addNew: {
    id: `${scope}.addNew`,
    defaultMessage: 'Add new',
  },
  scheduledLabel: {
    id: `${scope}.scheduledLabel`,
    defaultMessage: 'Scheduled',
  },
  scheduleLabel: {
    id: `${scope}.scheduleLabel`,
    defaultMessage: 'Schedule',
  },
  recurrenceLabel: {
    id: `${scope}.recurrenceLabel`,
    defaultMessage: 'Recurrence',
  },
  startTime: {
    id: `${scope}.startTime`,
    defaultMessage: 'Launch time',
  },
  willStartOn: {
    id: `${scope}.willStartOn`,
    defaultMessage: 'Launch date',
  },
  willEndOn: {
    id: `${scope}.willEndOn`,
    defaultMessage: 'End date',
  },
  willEnd: {
    id: `${scope}.willEnd`,
    defaultMessage: 'Will end',
  },
  willRepeatOn: {
    id: `${scope}.willRepeatOn`,
    defaultMessage: 'Will Repeat On',
  },
  willEndDesc: {
    id: `${scope}.willEndDesc`,
    defaultMessage: 'When it reaches the number of completes',
  },
  repeatsUntil: {
    id: `${scope}.repeatsUntil`,
    defaultMessage: 'Remaining repeats until end date:',
  },
  immmediateRunDesc: {
    id: `${scope}.immmediateRunDesc`,
    defaultMessage:
      'Your survey will be launched when our review team approves it.',
  },
  resumeRunning: {
    id: `${scope}.resumeRunning`,
    defaultMessage: 'Your survey will be launched immediately.',
  },
  recurrenceReminder: {
    id: `${scope}.recurrenceReminder`,
    defaultMessage:
      'Keep in mind that if the survey fails to reach the\n' +
      'number of completes during a recurrence, it will\n' +
      'continue running according to scheduling.',
  },
  repeatsLabel: {
    id: `${scope}.repeatsLabel`,
    defaultMessage: 'Repeats:',
  },
  selectEndDatePrompt: {
    id: `${scope}.selectEndDatePrompt`,
    defaultMessage: 'Please select end date for survey schedule',
  },
  selectStartDatePrompt: {
    id: `${scope}.selectStartDatePrompt`,
    defaultMessage: 'Please select launch date, time and timezone',
  },
  selectCustomStartDatePrompt: {
    id: `${scope}.selectCustomStartDatePrompt`,
    defaultMessage: 'Please enter date and time',
  },
  availableOnElitePlan: {
    id: `${scope}.availableOnElitePlan`,
    defaultMessage: 'Available on Elite Plan',
  },
  featureAvailableOnElitePlan: {
    id: `${scope}.featureAvailableOnElitePlan`,
    defaultMessage: 'This feature is available on <strong>Elite plan.</strong>',
  },
  availableOnElitePlanMessage: {
    id: `${scope}.availableOnElitePlanMessage`,
    defaultMessage:
      'Do you want to schedule your survey? This option is available on <strong>Elite plan.</strong>',
  },
  letsTalk: {
    id: `${scope}.letsTalk`,
    defaultMessage: "Let's talk",
  },
  errors: {
    missingStartDate: {
      id: `${scope}.errors.missingStartDate`,
      defaultMessage: 'Missing launch date',
    },
    missingCustomStartDate: {
      id: `${scope}.errors.missingCustomStartDate`,
      defaultMessage: 'Missing repeat date',
    },
    missingEndDate: {
      id: `${scope}.errors.missingEndDate`,
      defaultMessage: 'Missing end date',
    },
    pastDate: {
      id: `${scope}.errors.pastDate`,
      defaultMessage: 'The launch time must be at least two hours forward',
    },
    olderCustomDatesThanLaunchDate: {
      id: `${scope}.errors.olderCustomDatesThanLaunchDate`,
      defaultMessage: 'The launch date must be before the repeat date(s)',
    },
    missingTime: {
      id: `${scope}.errors.missingTime`,
      defaultMessage: 'Missing time',
    },
    missingTimezone: {
      id: `${scope}.errors.missingTimezone`,
      defaultMessage: 'Missing timezone',
    },
  },
});
